import React, { Suspense, useEffect, useState } from "react"
import _ from "lodash"
import { Outlet } from "react-router-dom"
import { ProductFruits } from "react-product-fruits"
import { createEnvironment } from "../../RelayEnvironment"
import {
  RelayEnvironmentProvider,
} from "react-relay"

import { LoadingMask } from "../../CommonStyles"

const WOZTELL_URL = process.env.REACT_APP_WOZTELL_URL
const GRAPHQLAPI_PATH = process.env.REACT_APP_GRAPHQLAPI_PATH

const Layout = () => {
  const [signedContext, setSignedContext] = useState(null)
  const [payload, setPayload] = useState(null)
  const [productFruitKey, setProductFruitKey] = useState(null)
  const userInfo = {
    username: productFruitKey,
  }

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      window.addEventListener("message", receiveMessage, false)
      window.parent.postMessage("iframeFinishLoading", "*")
    }
    return () => {
      window.removeEventListener("message", receiveMessage, false)
    }
  }, [])

  const receiveMessage = (event) => {
    const whitelistedOrigins = WOZTELL_URL.split("||")
    if (!whitelistedOrigins.includes(event.origin)) {
      return
    }
    if (event?.data) {
      if (!_.isEmpty(event.data?.payload)) {
        setPayload(event.data?.payload)
        setSignedContext(event.data?.signedContext)
        setProductFruitKey(event.data?.productFruitKey)
        // setLoading(false)
      }
    }
  }

  return (
    <RelayEnvironmentProvider environment={createEnvironment({
      url: GRAPHQLAPI_PATH,
      payload,
      signedContext,
    })}>
      <Suspense fallback={
        <LoadingMask>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </LoadingMask>
      }>
        <Outlet context={{
          encryption: {
            payload,
            signedContext
          }
        }} />
        {userInfo?.username && (
          <ProductFruits workspaceCode="x7ZCHDdpRx0mgZi8" language="en" user={userInfo} />
        )}
        {/* <InnerApp /> */}
      </Suspense>
    </RelayEnvironmentProvider>
  )
}


export default Layout